import React from "react";
import { useSelector } from "react-redux";
import GoogleStackedBarChart from "../../../../components/charts/googleChart/googleChart";

const TrendLineChart = () => {
  const {
    data_table: { rows = [], cols = [] },
    options
  } = useSelector((state) => state.activePackages.chartData);

  return (
    <GoogleStackedBarChart
      chartName="active_packages_by_trend_chart"
      chartType="LineChart"
      width="1350px"
      height={400}
      rows={rows}
      columns={cols}
      enableLineChartTooltip
      showAdditionTooltip={false}
      options={options}
    />
  );
};

export default TrendLineChart;
